export default function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full min-h-[60vh] items-center justify-center"
    >
      <div className="flex flex-col items-center gap-3 text-[color:var(--color-text-muted)]">
        <div
          className="h-8 w-8 animate-spin rounded-full border-2 border-[color:var(--color-text-muted)]/30 border-t-[color:var(--color-primary)]"
          aria-hidden
        />
        <span className="text-sm">{label}</span>
      </div>
    </div>
  );
}
